import React from 'react';
import {Elements} from '@stripe/react-stripe-js';
import {loadStripe} from "@stripe/stripe-js/pure";
import CheckoutForm from "./CheckoutForm";

const stripePromise = loadStripe('pk_test_51NDhFKCrGQbcfKLBBNvHHGVxwYvSk0npiPwC3Leb5KQqfqvQ1bjw42qIQI8ik8vMroW3U0QkwgkfepeK1Q1gmwBN00U7Vy2Csn');

const Check = (props) => (
    <Elements stripe={stripePromise}>
      <CheckoutForm data={props} onchange={(e) => { props.onchange(e) }} />
    </Elements>
  );
  export default Check;